export const greyhawkCalendar = {
  name: 'Greyhawk',
  months: [
    {
      name: 'Needfest',
      days: 7,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Fireseek',
      days: 28,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Readying',
      days: 28,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Coldeven',
      days: 28,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Growfest',
      days: 7,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Planting',
      days: 28,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Flocktime',
      days: 28,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Wealsun',
      days: 28,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Richfest',
      days: 7,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Reaping',
      days: 28,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Goodmonth',
      days: 28,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Harvester',
      days: 28,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Brewfest',
      days: 7,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Patchwall',
      days: 28,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: "Reasy'reat",
      days: 28,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Sunsebb',
      days: 28,
      leapDays: 0,
      leapPeriod: 0,
    },
  ],
  time: {
    minute: {
      name: 'Minute',
      plural: 'Minutes',
      duration: '60',
    },
    hour: {
      name: 'Hour',
      plural: 'Hours',
      duration: '3600',
    },
    day: {
      name: 'Day',
      plural: 'Days',
      duration: '86400',
    },
    month: {
      name: 'Month',
      plural: 'Months',
    },
    year: {
      name: 'Year',
      plural: 'Years',
      duration: '31449600',
    },
    decade: {
      name: 'Decade',
      plural: 'Decades',
      enabled: true,
      duration: '314496000',
    },
    century: {
      name: 'Century',
      plural: 'Centuries',
      enabled: true,
      duration: '3144960000',
    },
    millenium: {
      name: 'Millenium',
      plural: 'Millenia',
      enabled: true,
      duration: '31449600000',
    },
    myriad: {
      name: 'Myriad',
      plural: 'Myriads',
      enabled: true,
      duration: '314496000000',
    },
    epoch: {
      name: 'Epoch',
      plural: 'Epochs',
      enabled: true,
      duration: '3144960000000',
    },
    aeon: {
      name: 'Aeon',
      plural: 'Aeons',
      enabled: true,
      duration: '31449600000000',
    },
  },
  days: {
    showWeekDays: true,
    weekLength: 7,
    weekdays: [
      { name: 'Starday', abbr: 'Sta', order: 0, weekend: false },
      { name: 'Sunday', abbr: 'Sun', order: 1, weekend: false },
      { name: 'Moonday', abbr: 'Moo', order: 2, weekend: false },
      { name: 'Godsday', abbr: 'God', order: 3, weekend: true },
      { name: 'Waterday', abbr: 'Wat', order: 4, weekend: false },
      { name: 'Earthday', abbr: 'Ear', order: 5, weekend: false },
      { name: 'Freeday', abbr: 'Fre', order: 6, weekend: true },
    ],
    globalHolidays: [
      { name: 'New Years', day: 1, month: 0 },
      { name: 'Luna Morta', day: 18, month: 1 },
      { name: 'Luna Morta', day: 19, month: 1 },
      { name: 'Luna Morta', day: 20, month: 1 },
      { name: 'Festival of St. Bane', day: 1, month: 2 },
      { name: 'Rising Fest', day: 8, month: 2 },
      { name: 'Rising Fest', day: 9, month: 2 },
      { name: 'Rising Fest', day: 10, month: 2 },
      { name: 'Rising Fest', day: 11, month: 2 },
      { name: 'Rising Fest', day: 12, month: 2 },
      { name: 'Rising Fest', day: 13, month: 2 },
      { name: 'Rising Fest', day: 14, month: 2 },
      { name: 'Day of Lords', day: 24, month: 2 },
      { name: 'Fullmoon Festival', day: 11, month: 3 },
      { name: 'Banapas', day: 1, month: 4 },
      { name: "Atroa's Feast", day: 6, month: 4 },
      { name: "Fool's Dat", day: 7, month: 4 },
      { name: 'Courting Moon Festival', day: 4, month: 5 },
      { name: 'Tanabat', day: 11, month: 5 },
      { name: 'Harnekiah', day: 8, month: 6 },
      { name: 'Harnekiah', day: 9, month: 6 },
      { name: 'Harnekiah', day: 10, month: 6 },
      { name: 'Harnekiah', day: 11, month: 6 },
      { name: 'Harnekiah', day: 12, month: 6 },
      { name: 'Harnekiah', day: 13, month: 6 },
      { name: 'Harnekiah', day: 14, month: 6 },
      { name: 'Walpurgis', day: 18, month: 6 },
      { name: 'F. of Blinding Light', day: 1, month: 7 },
      { name: 'F. of Blinding Light', day: 2, month: 7 },
      { name: 'F. of Blinding Light', day: 3, month: 7 },
      { name: 'F. of Blinding Light', day: 4, month: 7 },
      { name: 'F. of Blinding Light', day: 5, month: 7 },
      { name: 'F. of Blinding Light', day: 6, month: 7 },
      { name: 'F. of Blinding Light', day: 7, month: 7 },
      { name: 'Luna Discordia', day: 10, month: 7 },
      { name: 'Luna Discordia', day: 11, month: 7 },
      { name: 'Bawming the Thorn', day: 16, month: 7 },
      { name: 'Ceremony of the Turning', day: 17, month: 7 },
      { name: "Midsummer's Day", day: 4, month: 8 },
      { name: 'Luna Vita', day: 18, month: 9 },
      { name: 'Luna Vita', day: 19, month: 9 },
      { name: 'Luna Vita', day: 20, month: 9 },
      { name: 'Feast of Frogs', day: 2, month: 10 },
      { name: 'Grandmote', day: 4, month: 10 },
      { name: "King's Festival", day: 5, month: 10 },
      { name: "King's Festival", day: 6, month: 10 },
      { name: "King's Festival", day: 7, month: 10 },
      { name: "King's Festival", day: 8, month: 10 },
      { name: "King's Festival", day: 9, month: 10 },
      { name: "Miner's Fairs", day: 26, month: 10 },
      { name: "Miner's Fairs", day: 27, month: 10 },
      { name: "Miner's Fairs", day: 28, month: 10 },
      { name: "Logger's Fest", day: 8, month: 11 },
      { name: "Logger's Fest", day: 9, month: 11 },
      { name: "Logger's Fest", day: 10, month: 11 },
      { name: "Logger's Fest", day: 11, month: 11 },
      { name: "Logger's Fest", day: 12, month: 11 },
      { name: "Logger's Fest", day: 13, month: 11 },
      { name: "Logger's Fest", day: 14, month: 11 },
      { name: 'Raksha Bandhan', day: 20, month: 11 },
      { name: "Osson's Ride", day: 1, month: 12 },
      { name: "Almor's Tears", day: 4, month: 12 },
      { name: 'Liberation Day', day: 7, month: 12 },
      { name: "Bellringer's Feast", day: 7, month: 13 },
      { name: 'Lammas', day: 14, month: 13 },
      { name: 'Wiccrhys', day: 18, month: 13 },
      { name: 'Turning of the Shebear Stone', day: 5, month: 14 },
      { name: 'Festival of Hope', day: 7, month: 14 },
      { name: 'Day of Remembrance', day: 11, month: 14 },
      { name: 'Day of Reflection', day: 12, month: 14 },
      { name: 'Day of Retribution', day: 13, month: 14 },
      { name: 'Great Freeday', day: 14, month: 14 },
      { name: 'Luna Pax', day: 10, month: 15 },
      { name: 'Luna Pax', day: 11, month: 15 },
      { name: 'Feast of Telchur', day: 21, month: 15 },
      { name: 'Marihwyd', day: 23, month: 15 },
      { name: 'Days of Thought', day: 25, month: 15 },
      { name: 'Days of Thought', day: 26, month: 15 },
      { name: 'Days of Thought', day: 27, month: 15 },
      { name: 'Days of Thought', day: 28, month: 15 },
    ],
  },
};
